import { PresetColorTypes } from '../_util/colors'; // eslint-disable-next-line import/prefer-default-export

export function isPresetColor(color) {
  return PresetColorTypes.indexOf(color) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/badge/utils.js
// module id = 251
// module chunks = 0